<template>
    <!-- 通知公告列表 -->
    <div class="notify">
        <div class="box_title">
            <div class="box_title_left">
                {{ cateName || name }}
            </div>
            <div class="box_title_right">
               <span class="el-icon-location-outline"></span> 当前位置:  <router-link to="/"> 首页 </router-link> /  {{ cateName || name }} 
            </div>
        </div>

        <!-- 列表 -->
        <div class="content_list">
            <div class="left">
                <div class="menu_item hvr-forward" v-for="(item, index) in leftMenu" :key="index" :class="active == index ? 'activeMenu' : '' " @click="MenuClick(item, index)">
                    <span class="iconfont icon-jiantou-copy"></span>
                    <span class="menu_name">{{ item.sCateName }}</span>
                </div>
            </div>
            <div class="right">
                <div class="notifyname">
                    {{ name }}
                </div>

                <!-- 通知列表 -->
                <div class="notify_content" v-if="aTpl == 7">
                    <div class="list_item" v-for="(item, index) in newsList" :key="index" @click="showDetail( item )">
                        <div class="item_left">
                            <div class="days">
                                {{ item.days }}
                            </div>
                            <div class="years">
                                {{ item.year }}
                            </div>
                        </div>
                        <div class="item_right">
                            <div class="item_title">
                                {{ item.newsTitle }}
                            </div>
                            <div class="item_content">
                                {{ item.newsContent }}
                            </div>
                        </div>
                        <div class="iconbox">
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                </div>

                <!-- 新闻列表 -->
                <div class="news_list" v-else>
                    <div class="news_item hvr-underline-from-center" v-for="(item, index) in newsList" :key="index" @click="showDetail( item )">
                        <div class="img_box">
                            <img :src="item.newsImg" v-if="item.newsImg && item.newsImg.indexOf('http') != -1" alt="">
                            <img :src="$ImgUrl + item.newsImg" v-if="item.newsImg && item.newsImg.indexOf('http') == -1" alt="">
                            <img src="../../assets/static/index/left_nav_bg3.png" v-if="!item.newsImg" alt="">
                        </div>
                        <div class="info_box">
                            <div class="news_title">
                                {{ item.newsTitle }}
                            </div>
                            <div class="news_content">
                                {{ item.newsContent }}
                            </div>
                            <div class="time_box">
                               <span class="iconfont icon-shijian"></span> 时间: {{ item.createTime }}
                            </div>
                        </div>
                        <div class="icon_box">
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page_box" v-if="newsList && newsList .length" style="text-align:right;">
            <el-pagination
            background
            layout="prev, pager, next"
            :current-page="pageNum"
            @current-change="pageChange"
            :page-size="10"
            :total="totalPage * 10">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Qs from "qs"
    export default {
        data() {
            return {
                name: this.$route.params.name,
                leftMenu: [],
                list: [],
                newsList: [],
                active: 0,
                LeftList: [],
                cateId: "",  //当前栏目id
                pageNum: 1,
                totalPage: 0,
                aTpl: "",
                cateName:"", //父级栏目名称
            }
        },
        computed: {
            // 子级栏目id
            id () {           
                return this.$route.params.id
            },
            // 父级栏目id 
            cateID(){
                return this.$route.params.cateID
            },
            // 该栏目索引
            index() {
                return this.$route.params.index
            },
        },
        watch: {
            id () {
                this.pageNum = 1
                this.cateId = this.id 
               
                this.getCateList()
                this.getClassList()
            },
            // cateID () {
            //     this.getClassList()
            //      this.getCateList()
            // },
            //  index() {
            //      this.getClassList()
            //      this.getCateList()
            // }
        },
        mounted () {
            this.leftMenu = []
            this.newsList = []
            this.getClassList();
       },
        methods: {
            // 点击按钮
            MenuClick ( item,index ) {
                this.active = index
                this.name = item.sCateName 
                this.cateId = item.sCateId
                this.aTpl = item.aTpl
                this.pageNum = 1
                this.getCateList()
                document.documentElement.scrollTop = 0
            },

            // 获取左侧分类
            async getClassList () {
                this.newsList = []
                this.active = this.index
                let res = await this.$axios.post("/lencon/pc/news/allCates", Qs.stringify({ cateId: this.cateID}))
                if ( res.data.code == 1 ) {
                    this.leftMenu = res.data.newsCateList
                    if ( !this.name ) {
                        this.name = this.leftMenu[0].sCateName
                    }else{
                        this.name = this.leftMenu[this.index].sCateName
                    }
                    if ( !this.cateId ) {
                        this.cateId = this.leftMenu[this.index].sCateId
                        this.getCateList()
                    }
                }
            },

            // 获取二级分类下的新闻列表
            async getCateList () {
                this.newsList = []       
                let res = await this.$axios.post("/lencon/pc/news/sonCates", { cateId: this.cateId, pageNum: this.pageNum })
                if ( res.data.code == 1 ) {
                    this.cateName = res.data.cateName
                    this.newsList = res.data.newsList
                    this.totalPage = res.data.totalPage
                    if ( this.aTpl == 7 ) {
                        this.newsList.forEach( el => {
                            let arr = el.createTime.split(" ")
                            let date = arr[0].split("-")
                            el.year = date[0]
                            el.days = `${date[1]}-${date[2]}`
                        })
                    }
                }
            },

            // 页码变化
            pageChange ( page ) {
                this.pageNum = page 
                this.getCateList()
            },

            // 新闻详情
            showDetail ( item ) {
                if(item.isLink == 1){
                    // 外链
                    window.open(item.linkUrl, "_blank")
                }else{
                    this.$router.push({
                        path: `/NewsDetail/${item.newsId}`,
                        query: {
                            cate_id: item.cate_id
                        }
                    })
                }
                
            }
        }
    }
</script>
<style>
.el-pagination{
    margin-top: 30px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
    color: #fff;
}
.hvr-underline-from-center:before {
    background: #2767c4  !important;
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/main.scss";

.notify {
    width: 1200px;
    margin: 0 auto 100px auto;
    .box_title {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        border-left: 4px solid #fff;
        margin: 20px 0;
        font-size: 16px;
        .box_title_left {
            font-size: 24px;
            font-weight: bold;
        }
        .box_title_right {
            font-size: 14px;
        }
    }
}
.content_list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .left {
        width: 210px;
        background-color: #fff;
        border-radius: 10px 0 0 0;
        padding-left: 20px;
        .menu_item {
            width: 100%;
            display: flex;
            align-items: center;
            // justify-content: center;
            padding: 20px 0;
            border-bottom: 1px solid #f5f5f5;
            cursor: pointer;
            color: #333;
            span {
                margin: 0 10px;
            }
            .iconfont {
                font-size: 12px;
            }
        }
        .activeMenu {
            color: #2767c4 ;
        }
    }
    .right {
        width: 980px;
        background-color: #fff;
        border-radius: 0 10px 0 0;
        padding: 30px;
        .notifyname {
            font-size: 20px;
            font-weight: bold;
            line-height: 60px;
            color: #343434;
            border-bottom: 1px solid #eeeeee;
        }
        .notify_content {
            width: 100%;
            margin-top: 30px;
            .list_item {
                width: 100%;
                display: flex;
                align-items: center;
                // justify-content: space-between;
                cursor: pointer;
                margin: 30px 0;
                .item_left {
                    width: 120px;
                    .days {
                        font-size: 30px;
                        font-weight: bold;
                        color: #2767c4 ;
                    }
                    .years {
                        font-size: 14px;
                        color: #b3b3b3;
                    }
                }
                .item_right {
                    width: 520px;
                    margin-left: 30px;
                    .item_title {
                        font-size: 18px;
                        color: #2767c4 ;
                        line-height: 30px;
                    }
                    .item_content {
                        font-size: 14px;
                        color: #7A7A7A;
                        margin-top: 10px;
                        @include MultipleRows(2);
                    }
                }
                .iconbox {
                    flex: 1;
                    text-align: right;
                }
            }
        }

        .news_list {
            width: 100%;
            margin-top: 30px;
            .news_item {
                width: 100%;
                display: flex;
                align-items: center;
                // margin: 20px 0;
                padding: 20px 0;
                cursor: pointer;
                .img_box {
                    width: 265px;
                    height: 200px;
                    img {
                        width: 265px;
                        height: 200px;
                    }
                }
                .info_box {
                    margin-left: 20px;
                    width: 520px;
                    
                    .news_title {
                        font-size: 18px;
                        line-height: 40px;
                        @include SingleRow();
                    }
                    .news_content {
                        font-size: 15px;
                        color: #7A7A7A;
                        height: 80px;
                        @include MultipleRows(4);
                    }
                    .time_box {
                        font-size: 14px;
                        color: #8E8E8E;
                        line-height: 40px;
                    }
                }
                .icon_box {
                    flex: 1;
                    text-align: right;
                }
            }
        }


    }
}
</style>